import { PaymentMethodDetailResult } from '@mews-commander/data-access';

export const hasPaymentMethodDetailStatusHistory = (paymentMethod: PaymentMethodDetailResult) =>
    !!paymentMethod.sepa?.statusHistory?.length || !!paymentMethod.paymentCard?.statusHistory?.length;
